routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.reportPaymentHistory', {
      url: "reportes/historico-pagos",
      template: `<report-payment-history sh-ctrl="shCtrl"></report-payment-history>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/reports/payment-history/payment-history.config.js
 **/